import { Component, NgZone, ViewChild } from '@angular/core';
import { BciWkSnackbarsComponent } from '@bci/webkitbci';
import { shareReplay, take, tap } from 'rxjs';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { SnackbarService } from 'src/app/services/snackbars/snackbar.service';

@Component({
	selector: 'app-snackbar',
	templateUrl: './snackbar.component.html',
	styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent {
	@ViewChild(BciWkSnackbarsComponent) snackbarsRef: BciWkSnackbarsComponent;
	snackbarState$ = this.snackbarService.snackbarState$.pipe(
		tap(state => {
			if (state) {
				if (state.tag) {
					this.gtmService.handlerEvent(state.tag);
				}

				this.ngZone.onStable.pipe(take(1)).subscribe(() => {
					this.snackbarsRef?.init();
				});
			}
		}),
		shareReplay(1)
	);

	constructor(
		private readonly snackbarService: SnackbarService,
		private readonly ngZone: NgZone,
		private readonly gtmService: GtmService
	) {}
}
